import React from "react";
import "./modal.css";
import PropTypes from "prop-types";
import { close } from "react-icons-kit/ikons/close";
import { Icon } from "react-icons-kit";

const CloseIcon = () => (
  <div style={{ color: "grey" }}>
    <Icon size={24} icon={close} />
  </div>
);

export default class Modal extends React.Component {
  onClose = (e) => {
    this.props.onClose && this.props.onClose(e);
  };
  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <div class={this.props.isCircle ? "modal circle" :"modal"} id="modal">
        <div
          class="toggle-button"
          style={this.props.isCircle ? {padding:'5px',marginTop:'5px'} :{ float: "left",padding:'5px' }}
          onClick={this.onClose}
        >
          <CloseIcon/>
        </div>
        <div class="content">{this.props.children}</div>
      </div>
    );
  }
}
Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
};
